<template>
  <div style="padding: 0 8px">
    <NoticeBar :scrollable="false" style="margin-top: 7px">
      <Swipe
        vertical
        class="notice-swipe"
        :autoplay="3000"
        :show-indicators="false"
      >
        <SwipeItem>① 选择对应的考试场次</SwipeItem>
        <SwipeItem>② 调整至你想要的考试参数</SwipeItem>
        <SwipeItem>③ 点击最下方提交订单、付款即可</SwipeItem>
      </Swipe>
    </NoticeBar>
    <NoticeBar
      :scrollable="false"
      style="margin-top: 7px"
      background="#F19C73"
      color="#FFFFFF"
      left-icon="info-o"
      @click="click_attention"
    >
      <Swipe vertical class="notice-swipe" :show-indicators="false">
        <SwipeItem>重要!!! 点我查看注意事项</SwipeItem>
      </Swipe>
    </NoticeBar>
    <p class="StepClass">选择考试</p>
    <ConfigProvider :theme-vars="data.themeVars">
      <Skeleton :row="5" :loading="data.loading">
        <RadioGroup v-model="data.checked">
          <CellGroup>
            <Cell
              clickable
              @click="handleCellClick(index)"
              v-for="(item, index) in data.examList_is"
              v-bind:key="index"
              :Examid="item.examId"
              :style="item.isChoosable ? {} : { background: '#f1f1f1' }"
            >
              <circleExam :item="item"></circleExam>
              <template #right-icon>
                <span class="DiyTag" :style="CurrentTagColor(item.status)">
                  {{ item.status }}
                </span>
              </template>
              <template #extra>
                <Radio :name="index.toString()" :disabled="!item.isChoosable" />
              </template>
            </Cell>
          </CellGroup>
        </RadioGroup>
      </Skeleton>
      <Collapse v-model="activeNames" style="padding-top: 5px">
        <CollapseItem title="不在进行时的考试" name="1">
          <CellGroup>
            <Cell
              clickable
              @click="handleCellClick(index)"
              v-for="(item, index) in data.examList_no"
              v-bind:key="index"
              :style="item.isChoosable ? {} : { background: '#f1f1f1' }"
            >
              <circleExam :item="item"></circleExam>
              <template #right-icon>
                <span class="DiyTag" :style="CurrentTagColor(item.status)">
                  {{ item.status }}
                </span>
              </template>
            </Cell>
          </CellGroup>
        </CollapseItem>
      </Collapse>
      <p class="StepClass">考试参数</p>
      <sliderParameterVue
        v-model:examTime="data.examTime"
        v-model:examScore="data.examScore"
        @handleDragEnd="handleDragEnd"
      />
      <p class="StepClass">预估金额</p>
      <p class="settlement" style="padding-bottom: 70px">
        {{ totalSubjects }}(题) * 0.08(单价) =
        <span class="amount">{{ amount_1 }}</span> 元
      </p>
    </ConfigProvider>
  </div>
</template>
<script setup>
import { useData } from "@/composables/useData.js";
import circleExam from "./components/circleExam.vue";
import { examService } from "@/service/examService.js";
import sliderParameterVue from "@/components/sliderParameter.vue";
import { ref, computed, watch } from "vue";
import {
  RadioGroup,
  Radio,
  CellGroup,
  Cell,
  ConfigProvider,
  Notify,
  Skeleton,
  Swipe,
  SwipeItem,
  NoticeBar,
  Dialog,
  Collapse,
  CollapseItem,
} from "vant";
const { sitedData } = useData();
const data = ref({
  checked: "-1",
  // amount: 2,
  loading: true,
  examTime: {
    _value: 0,
    _max: 1800,
  },
  examScore: {
    _value: 0,
    _max: 100,
  },
  themeVars: {
    circleTextColor: "#777777",
  },
  examList_is: [],
  examList_no: [],
});
const activeNames = ref(["0"]);
// 计算总题数
const totalSubjects = computed({
  get() {
    if (data.value.checked === "-1") {
      return 0;
    }
    // 如果不为空返回
    if (!data.value.examList_is[data.value.checked]) {
      return 0;
    }
    return data.value.examList_is[data.value.checked].totalSubjects;
  },
});
// 计算总金额
const amount_1 = computed({
  get() {
    if (data.value.checked === "-1") {
      return 0;
    }
    let Price = totalSubjects.value * 0.08;
    return Price.toFixed(2);
  },
});

// Cell点击事件
const handleCellClick = (index) => {
  if (data.value.examList_is[index].isChoosable) {
    data.value.checked = index.toString();
  }
};

// 弹出注意事项窗口
const click_attention = () => {
  Dialog.alert({
    message: `①. 提交订单开始考试后，考试不可暂停、停止、取消。
②. 开始考试后切勿自行在易班优课考试中操作以免考试失败，等待代考系统倒计时结束方可在易班查看。
③. 本页面选取的分数可能不是最终分数，代考系统会根据您的考试每题分数进行计算，若不可达到指定分数将会将分数向上取整。
④. 由于一些网络问题，代考系统有很小的概率会考试失败(0.01%)，若考试失败，可联系客服退款，介意者请勿下单。`,
    title: "注意事项",
    theme: "round-button",
    confirmButtonText: "我鸡掉了",
    messageAlign: "left",
  });
};

// 改变考试参数
const changeExamParam = (index) => {
  const { examScore, examTime, examList_is } = data.value;
  if (!examList_is[index]) return;
  // 更新滑动条组件
  examScore._max = examList_is[index].totalPoints;
  if (examTime._max > examList_is[index].duration * 60) {
    examTime._max = examList_is[index].duration * 60;
  }
  // 推荐分数以及目标时间
  if (examScore._max > 10) {
    examScore._value = examScore._max - 5;
  } else {
    // 推荐分数等于总分数的80%
    examScore._value = Math.ceil(examScore._max * 0.96);
  }

  examTime._value = examTime._max / 2;
  // 更新订单共享数据
  updateOrderData(index);
};

// 更新共享订单数据
const updateOrderData = (index = -1) => {
  const { examList_is } = data.value;
  // 更新共享数据中关于订单的数据
  if (index != -1) {
    sitedData.value.order.examTitle = examList_is[index].name;
    sitedData.value.order.examId = examList_is[index].examId;
  }
  sitedData.value.order.orderPrice = amount_1.value;
  sitedData.value.order.targetScores = data.value.examScore._value;
  sitedData.value.order.targetExamTime = data.value.examTime._value;
  sitedData.value.order.maxScores = data.value.examScore._max;
  sitedData.value.order.maxExamTime = data.value.examTime._max;
};

// 返回对应状态的颜色
const CurrentTagColor = (status) => {
  switch (status) {
    case "待开始":
      return { backgroundColor: "#1ba8dd" };
    case "未答题":
      return { backgroundColor: "#fa5a29" };
    case "已答题":
      return { backgroundColor: "#ffb9a3" };
    case "已完成":
      return { backgroundColor: "#75d701" };
    case "已结束":
      return { backgroundColor: "#8c8c8c" };
    default:
      return { backgroundColor: "#8c8c8c" };
  }
};

// 判断当前时间是否在两个时间内
const isInTime = (startTime, endTime) => {
  const nowTime = new Date().getTime();
  // 苹果手机转时间戳
  const start = new Date(startTime.replace(/-/g, "/")).getTime();
  const end = new Date(endTime.replace(/-/g, "/")).getTime();
  if (nowTime >= start && nowTime <= end) {
    return true;
  } else {
    return false;
  }
};

// 考试分数滑动条结束拖动事件
const handleDragEnd = () => {
  updateOrderData();
};

// 过滤考试列表显示状态
// const filterExamList = (examList, isChoosable) => {
//   return examList.filter((item) => {
//     return item.isChoosable == isChoosable;
//   });
// };

// 监听是否跳转至考试选择标签
watch(
  () => sitedData.value.Step,
  (newVal) => {
    if (newVal === 1) {
      // 读取用户考试数据
      const { userID } = sitedData.value.user;
      // 重置默认选择项
      data.value.checked = "-1";
      // 显示骨架图
      data.value.loading = true;
      // 读取考试数据
      if (userID == "" || sitedData.value.groupID == "") {
        return;
      }
      examService
        .getEaxmList(
          userID,
          sitedData.value.groupID,
          sitedData.value.user.yibanID,
          sitedData.value.user.userToken
        )
        .then((res) => {
          res.result.forEach((item) => {
            // 加入考试列表
            // 剩余重做试卷次数
            let isChoosable =
              isInTime(item.started, item.expired) &&
              !(item.status == "已完成" && item.restNums == 0);
            let appendExam = {
              name: item.name,
              started: item.started,
              expired: item.expired,
              score: item.score,
              duration: item.duration,
              peopleNums: item.numbers,
              totalSubjects: item.totalSubject,
              totalPoints: item.totalPoints,
              status: item.status,
              examId: item.examId,
              isChoosable,
            };
            // 可选与不可选用filte加入到不同的数组
            if (isChoosable) {
              data.value.examList_is.push(appendExam);
              // console.log(data.value.examList_is);
            } else {
              data.value.examList_no.push(appendExam);
            }
            data.value.loading = false;
            // isChoosable 初始下标
            if (isChoosable && data.value.checked === "-1") {
              // data.value.checked = (data.value.examList.length - 1).toString();
              data.value.checked = "0";
            }
          });
          if (data.value.checked === "-1") {
            sitedData.value.page2_StepState = false;
            Notify("所填群组无有效考试选择，请重新填写!");
            return;
          }
          changeExamParam(0);
          sitedData.value.page2_StepState = true;
        })
        .catch((res) => {
          Notify(res == "" ? "网络通信问题，请再试一次" : res);
        });
    } else {
      data.value.examList_is = [];
      data.value.examList_no = [];
    }
  }
);
// 监视考试列表选中索引
watch(
  () => data.value.checked,
  (newVal) => {
    // newVal转int
    changeExamParam(parseInt(newVal));
  }
);
</script>

<style scoped>
.notice-swipe {
  height: 40px;
  line-height: 40px;
}
.card-content {
  display: flex;
  align-items: center;
}

.card-content .circle {
  margin-right: 10px;
}

.card-content p {
  font-size: 12px;
  text-align: left;
  margin: 5px 0;
  line-height: 1.1em;
}

.Tag_ {
  margin-right: 5px;
  padding-top: 1px;
}

.titleColor {
  color: #60ad80;
}

.StepClass {
  margin: 0px;
  padding: 23px 0 5px 13px;
  text-align: left;
  color: #8f999f;
  font-size: 14px;
}

.SilderClass {
  text-align: center;
  width: 60px;
}

.settlement {
  display: flex;
  align-items: baseline;
  justify-content: center;
  font-size: 14px;
  color: #828282;
  letter-spacing: 0.25em;
}

.amount {
  color: #f65454;
  font-weight: 500;
  font-size: 42px;
}

.DiyTag {
  color: white;
  height: 1.65em;
  padding: 0 5px;
  border-radius: 5px;
}
</style>
<style>
.van-collapse-item__content {
  padding: 0px;
}
</style>
